import { resolveStage } from '@adflow/ad-resolution';

/** Match TemplateBuilderPreview Design tab: no custom URL rewrite without a fixture. */
export function resolveSoccerCustomAssetUrlsForEditor(
  dataSources: ReadonlyArray<{ id: string; type: string }> | undefined,
): boolean {
  return resolveStage(dataSources).kind !== 'valid';
}
